<template>
  <div class="orderContent">
    <navBar :title="topTitle"></navBar>
    <div class="box flexBetween">
      <div class="left">收件人</div>
      <div class="right">{{orderInfo.receipt_user}}</div>
    </div>
    <div class="box flexBetween">
      <div class="left">包裹数量</div>
      <div class="right">{{orderInfo.qty}}</div>
    </div>
    <div class="box orderInfo">
      <div class="title">包裹内容</div>
      <div class="expressContent">{{orderInfo.express_content}}</div>
    </div>
    <div class="box orderInfo">
      <div class="title">取件截图</div>
      <div class="expressImg flexLeft">
        <div class="imgBox" v-for="(iItem,iIndex) in orderInfo.images" @click="showImg(iIndex)">
          <img :src="orderInfo.images[iIndex]" alt="">
        </div>
      </div>
    </div>
    <div class="orderInfo box">
      <div class="title">配送地址</div>
      <div class="telBox flexBetween">
        <div class="left">
          <div class="address">{{orderInfo.express_address?orderInfo.market_name +
            orderInfo.express_address.building_room:''}}
          </div>
          <div class="info">{{orderInfo.express_address?orderInfo.account_name + ' ' +
            orderInfo.express_address.mobile:''}}
          </div>
        </div>
        <div class="phone" @click="contactUser"></div>
      </div>
    </div>
    <div class="orderInfo box">
      <div class="title">订单信息</div>
      <div class="infoCont">
        <div class="orderSn flexBetween">
          <div class="name">订单号</div>
          <div class="value">{{orderInfo.market_express_sn}}
            <span v-clipboard:copy="orderInfo.market_express_sn" v-clipboard:success="copySuc"
                  v-clipboard:error="copyFail">复制</span></div>
        </div>
        <div class="orderTime flexBetween">
          <div class="name">下单时间</div>
          <div class="value">{{orderInfo.create_time}}</div>
        </div>
      </div>

    </div>
    <!--代配送订单流程-->
    <div class="box" v-if="statusId!=10" style="position:relative;margin-bottom: 40px;">
      <van-steps direction="vertical" active="10" active-color="#8D95A6">
        <van-step v-for="(sItem,sIndex) in orderInfo.express_log" :key="sIndex">
          <div class="flexBetween">
            <b class="title">{{sItem.content}}</b>
            <p class="time">{{sItem.opeate_time}}</p>
          </div>
        </van-step>
      </van-steps>
      <div class="failInfo" v-if="statusId==1" style="position:absolute;top: 30px;left: 50px;color: #DE1919;font-weight: bold;">失败原因：{{orderInfo.comment}}</div>
    </div>

    <van-button type="primary" block @click="sureOrder"
                :loading="loading"
                loading-type="circular"
                :loading-text="buttonText" v-if="statusId==10||statusId==30">{{buttonText}}
    </van-button>

    <div class="btnGroup" v-if="statusId==20">
      <van-button color="#687BFF" block @click="sureOrder"
                  :loading="loading"
                  :disabled="isDisable"
                  loading-type="circular"
                  :loading-text="buttonText">{{buttonText}}
      </van-button>
      <van-button color="#DE1919" plain block @click="pickerShow = true">取件失败</van-button>
    </div>

    <!--取件失败原因-->
    <van-overlay :show="pickerShow">
      <van-picker
              show-toolbar
              title="取件失败原因"
              :columns="columns"
              @cancel="pickerShow = false"
              visible-item-count="3"
              @confirm="pickerConfirm"
      />
    </van-overlay>
  </div>
</template>

<script>
  import navBar from "../../components/navBar";
  import Vue from 'vue';
  import {Toast, Button, Loading, Step, Steps,Dialog,ImagePreview,Picker,Overlay} from 'vant';

  Vue.use(Toast).use(Button).use(Loading).use(Step).use(Steps).use(Dialog).use(ImagePreview).use(Picker).use(Overlay);
  export default {
    name: "orderContent",
    components: {
      navBar
    },
    data() {
      return {
        isDisable:false,
        pickerShow:false,//选择器显示
        columns:['取件码错误','收件人错误','收件人手机号错误'],//取件失败原因
        topTitle: '',
        loading: false,//按钮加载
        orderInfo: {},
        orderId: this.$route.query.id,
        statusId: this.$route.query.status,
        buttonText: ''
      }
    },
    mounted() {
      this.getTopTitle();
      this.getOrderInfo();
    },
    methods: {
      pickerConfirm(value){
        this.pickerShow = false;
        this.sendHttp({
          method: 'post',
          url: `${this.orderUrl}/marketexpressreceipt/fail`,
          data: {
            market_express_id: this.orderId,
            fail_msg:value
          }
        }).then(res=>{
          if(res.code=='0'){
            this.$router.push('/qjOrder');
          }
          Toast(res.msg)
        })
      },

      //图片打开
      showImg(){
        if(this.orderInfo.images){
          ImagePreview({
            images: this.orderInfo.images,
            startPosition: 1,
            onClose() {
              // do something
            }
          });
        }

      },
      //拨打电话
      contactUser(){
        Dialog.confirm({
          message: this.orderInfo.express_address.mobile,
          confirmButtonText:'呼叫'
        }).then(() => {
          window.location.href = `tel:${this.orderInfo.express_address.mobile}`;
        }).catch(() => {
          // on cancel
        });

      },
      //订单提交
      sureOrder() {
        this.isDisable = true;
        let statusId = this.statusId;
        //待确认提交
        if (this.orderId && statusId == '10') {
          this.loading = true;
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/marketexpressreceipt/confirm`,
            data: {
              market_express_id: this.orderId
            }
          }).then(res => {
            this.loading = false;
            this.isDisable = false;
            if (res.code == '0') {
              this.$router.push('/qjOrder');
            }
            Toast(res.msg);
          })
        }

        //代取件提交
        if (this.orderId && statusId == '20') {
          this.loading = true;
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/marketexpressreceipt/buy`,
            data: {
              market_express_id: this.orderId
            }
          }).then(res => {
            this.loading = false;
            this.isDisable = false;
            console.log(res)
            if (res.code == '0') {
              this.$router.push('/qjOrder');
            }
            Toast(res.msg);
          })
        }

        //代配送提交
        if (this.orderId && statusId == '30') {
          this.loading = true;
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/marketexpressreceipt/finish`,
            data: {
              market_express_id: this.orderId
            }
          }).then(res => {
            this.loading = false;
            this.isDisable = false;
            console.log(res)
            if (res.code == '0') {
              this.$router.push('/qjOrder');
            }
            Toast(res.msg);
          })
        }

      },
      //获取头部标题
      getTopTitle() {
        let statusId = this.$route.query.status;
        if (statusId == 0) {
          this.topTitle = '取件-已取消';
        }
        if (statusId == 1) {
          this.topTitle = '取件失败';
        }
        if (statusId == 10) {
          this.topTitle = '取件-待确认';
          this.buttonText = '确认';
        }
        if (statusId == 20) {
          this.topTitle = '取件-待取件';
          this.buttonText = '取件完成';
        }
        if (statusId == 30) {
          this.topTitle = '取件-待配送';
          this.buttonText = '配送完成';
        }
        if (statusId == 50) {
          this.topTitle = '代购-已完成';
        }
      },
      //获取当前订单详情
      getOrderInfo() {
        if (this.orderId) {
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/marketexpressreceipt/detail`,
            data: {
              market_express_id: this.orderId
            }
          }).then(res => {
            console.log(res)
            this.orderInfo = res.data;
          })
        }
      },
      copySuc() {
        Toast('复制成功');
      },
      copyFail() {
        Toast('复制失败');
      }
    }
  }
</script>

<style scoped lang="less">
  .van-overlay{
    display: flex;
    align-items: flex-end;
    z-index:100;
  }
  .van-picker{
    width: 100%;
  }
  .btnGroup{
    margin: 20px 0;
    .van-button--block{
      width: 347px;
      margin: 20px auto;
      border: none;
      font-size: 16px;
    }
  }
  .expressImg{
    height: 88px;
    .imgBox{
      width: 70px;
      height: 70px;
      overflow: hidden;
      margin: 10px 0;
      margin-right: 16px;
      img{
        width: 100%;
      }
    }
  }
  .expressContent{
    padding: 6px 0;
    line-height: 24px;
  }
  .van-button--primary {
    background-color: #687BFF;
    border: none;
    font-size: 16px;
    width: 347px;
    margin: 30px auto;
    height: 48px;
    line-height: 48px;
  }

  .orderContent {
    background: #f5f5f5;
    position: absolute;
    width: 100%;
    min-height: 100%;

    .box {
      background: #fff;
      margin-top: 6px;
      padding: 0 14px;

      .left {
        padding: 12px 0;

        .info {
          color: #8D95A6;
          font-size: 13px;
          line-height: 30px;
        }
      }

      .phone {
        width: 17px;
        height: 17px;
        background: url("../../assets/images/phone.png") no-repeat;
        background-size: contain;
      }
    }

    .orderInfo {
      .title {
        line-height: 44px;
        border-bottom: 1px solid #F5f5f5;
        font-weight: bold;
      }

      .infoCont {
        line-height: 26px;
        padding: 10px 0;

        .name {
          color: #8D95A6;
        }

        .value {
          span {
            padding-left: 10px;
            color: #687BFF;
            text-decoration: underline;
          }
        }
      }

    }

    .orderitem {
      line-height: 40px;
      font-size: 14px;

      .bPrice {
        color: #687BFF;
      }

      .rPrice {
        color: #DE1919;
      }
    }
  }

</style>
<style>
  .van-picker-column__item{
    color: #687BFF;
  }
  .van-picker__title{
    font-size: 18px;
  }
  .van-step--finish .van-step__circle, .van-step--finish .van-step__line {
    background: #8D95A6 !important;
  }
</style>
